import * as FutureFragment from "@eyeo-fragments/in-product-messaging/background";
import { getFutureFragmentOverrides } from "./fragment-overrides";
import { getFutureStartInfo } from "./start-info";
export function getFragment() {
    return { ...FutureFragment, ...getFutureFragmentOverrides() };
}
export function isFutureFragment() {
    return true;
}
async function startFragment() {
    const fragment = getFragment();
    const futureStartInfo = await getFutureStartInfo();
    await fragment.start(futureStartInfo);
}
export async function start() {
    await startFragment();
}
